import Product from '@src/quince-site-common/src/domains/Product'
import { ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'

export const getIsCurrentProductOptionLeavingSoon = (
  product: Product,
  updatedSelectedOptions?: ProductVariantOption[],
) => {
  if (!product.variants) return false

  const variants = productHelper.getVariantsForOptions(product, updatedSelectedOptions)
  if (variants.length === 1) {
    return variants[0]?.lastChance === 'true'
  }
  return false
}

export const getVideoInfoForColor = (product: Product, currentColor: string | null): string | undefined => {
  if (!currentColor || !product.videos) return undefined

  const colorOptions: ProductVariantOption[] = [
    new ProductVariantOption({
      name: ProductOptionName.Color,
      value: currentColor,
    }),
  ]
  const videos = productHelper.getVideoForOptions(product, colorOptions)
  return videos?.[0]?.video?.id
}
